import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import { getCurrentAdmin } from '../config/adminConfig';

function ProtectedAdminRoute({ children }) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem('adminUser');
    const loginTime = localStorage.getItem('adminLoginTime');
    
    if (savedUser && loginTime) {
      // 8-hour session expiry
      const elapsed = Date.now() - parseInt(loginTime);
      const eightHours = 8 * 60 * 60 * 1000;
      
      if (elapsed < eightHours) {
        setIsAuthenticated(true);
        setCurrentUser(savedUser);
      } else {
        // Session expired — clear and force re-login
        localStorage.removeItem('adminUser');
        localStorage.removeItem('adminLoginTime');
      }
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (email) => {
    localStorage.setItem('adminLoginTime', Date.now().toString());
    setIsAuthenticated(true);
    setCurrentUser(email);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminUser');
    localStorage.removeItem('adminLoginTime');
    setIsAuthenticated(false);
    setCurrentUser(null);
    navigate('/');
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  return (
    <div>
      <div className="admin-header">
        <span>Welcome, {currentUser}</span>
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>
      {children}
    </div>
  );
}

export default ProtectedAdminRoute;